import * as React from "react";

import GenButton from "./Button";

interface GenSelectBarProps<Item> {
  selected: Array<Item>;
  setListSelected: (listSelected: Array<Item>) => void;
  listData?: Array<Item>;
  itemType?: string;
  selectionDescription?: (selectItems: Array<Item>) => string;
  selectExtraButtons?: React.ReactElement;
}

export default function GenSelectBar<Item>(
  {
    selected,
    setListSelected,
    listData,
    itemType,
    selectionDescription,
    selectExtraButtons,
  }: GenSelectBarProps<Item>,
) {
  const handleSelectAll = (e: React.MouseEvent) => {
    e.preventDefault();

    selected.length > 0
      ? setListSelected([])
      : setListSelected((listData || []));
  };

  const selectText = `Select ${listData ? `${listData.length} ` : ""} Shown`;

  return (
    <div className="gen-select-list-buttons">
      <div className="gen-select-list-buttons-left flex gap-2 items-baseline">
        <GenButton name={selected.length > 0 ? "Deselect All" : selectText} onClick={handleSelectAll} highlighted small/>
        <span>{selected.length} {itemType} selected</span>
        <span>{selectionDescription && selectionDescription(selected)}</span>
      </div>
      <div className="gen-select-list-buttons-right">
        {selectExtraButtons}
      </div>
    </div>
  );
}
